module.exports = __webpack_public_path__ + "img/rahmenregal.cd146516.jpg";